export const formationData = [
  {
    imageSrc: "/assets/images/home/automobile.png",
    imageTitle: "Automobile",
    roles: [
      { title: "Software Developer", link: "/formation-software-developer" },
      { title: "System Engineer", link: "/formation-system-engineer" },
      { title: "Lighting", link: "/formation-lighting" },
      { title: "Liaison au sol", link: "/formation-liaison-sol" },
    ],
  },
  {
    imageSrc: "/assets/images/home/nucleaire.png",
    imageTitle: "Nucleaire",
    roles: [
      {
        title: "Ingénieur Sureté Nucléaire",
        link: "/formation-ingenieur-surete-nucleaire",
      },
      {
        title: "Ingénieur fonctionnement nucléaire",
        link: "/formation-ingenieur-fonctionnement-nucleaire",
      },
      {
        title: "Ingénieur qualité nucléaire",
        link: "/formation-ingenieur-qualite-nucleaire",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/ferroviaire.png",
    imageTitle: "Ferroviaire",
    roles: [
      {
        title: "Ingénieur Système Ferroviaire",
        link: "/formation-ingenieur-systeme-ferroviaire",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/aeronautique.png",
    imageTitle: "Aéronautique",
    roles: [
      {
        title: "Concepteur systèmes embarqués",
        link: "/formation-concepteur-systemes-embarques",
      },
      {
        title: "Technicien banc d’essai",
        link: "/formation-technicien-banc-essai",
      },
    ],
  },
  {
    imageSrc: "/assets/images/home/navale.png",
    imageTitle: "Navale",
    roles: [
      {
        title: "Dessinateur construction navale",
        link: "/formation-dessinateur-construction-navale",
      },
      {
        title: "Dessinateur projeteur tuyauterie",
        link: "/formation-dessinateur-projeteur-tuyauterie",
      },
    ],
  },
];
